import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { wacToken } from "@/libraries/design/foundations";
import {
    Stats,
    StatsModuleProps
} from "@/libraries/design/patterns/stats/src/stats";

export const GlobalStatsSection = () => {
    const intl = useIntl();

    const statsProps: StatsModuleProps = {
        headerText: intl.formatMessage({
            id: "CustomersLandingPage.stats.header",
            defaultMessage: "Teams across the globe run on Atlassian"
        }),
        bigStat: {
            stat: "300000",
            statText: intl.formatMessage({
                id: "CustomersLandingPage.numberOfCustomersTxt",
                defaultMessage:
                    "companies power team collaboration with Atlassian"
            }),
            statColor: wacToken("color.primary.blue"),
            statSymbol: {
                symbolCharacter: "+",
                symbolCharacterColor: wacToken("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: "200",
                statText: intl.formatMessage({
                    id: "CustomersLandingPage.numberOfCountriesTxt",
                    defaultMessage:
                        "countries and territories have companies that use Atlassian"
                }),
                statColor: wacToken("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "+",
                    symbolCharacterColor: wacToken("color.primary.blue")
                }
            },
            {
                stat: "80",
                statText: intl.formatMessage({
                    id: "CustomersLandingPage.fortune500CompaniesTxt",
                    defaultMessage:
                        "of Fortune 500 companies use Atlassian products"
                }),
                statColor: wacToken("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: wacToken("color.primary.blue")
                }
            }
        ]
    };
    return (
        <UFOSegment name="customers-page-stats">
            <section>
                <Stats {...statsProps} />
            </section>
        </UFOSegment>
    );
};
